import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { AuthGuard2 } from './auth.guard2';



const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },

  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: "list",
    loadChildren: () =>
      import("./list/list.module").then((m) => m.ListPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: "requests",
    loadChildren: () =>
      import("./requests/requests.module").then((m) => m.RequestsPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "requests",
    loadChildren: () =>
      import("./requests/requests.module").then((m) => m.RequestsPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: "solar",
    loadChildren: () =>
      import("./solar/solar.module").then((m) => m.SolarPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: "transaction",
    loadChildren: () =>
      import("./transaction/transaction.module").then(
        (m) => m.TransactionPageModule
      ),
    canActivate: [AuthGuard2],
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((m) => m.DashboardPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: "search-indpower",
    loadChildren: () => import('./search-indpower/search-indpower.module').then( m => m.SearchIndpowerPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: 'lead-ltd',
    loadChildren: () => import('./lead-ltd/lead-ltd.module').then( m => m.LeadLtdPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: 'campaign',
    loadChildren: () => import('./campaign/campaign.module').then( m => m.CampaignPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: 'cust-transaction',
    loadChildren: () => import('./cust-transaction/cust-transaction.module').then( m => m.CustTransactionPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: 'scheme-tracker',
    loadChildren: () => import('./scheme-tracker/scheme-tracker.module').then( m => m.SchemeTrackerPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: 'upload',
    loadChildren: () => import('./upload/upload.module').then( m => m.UploadPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: 'coupon-admin',
    loadChildren: () => import('./coupon-admin/coupon-admin.module').then( m => m.CouponAdminPageModule),
    canActivate: [AuthGuard2],
  },
  {
    path: 'secondary-page',
    loadChildren: () => import('./secondary-page/secondary-page.module').then( m => m.SecondaryPagePageModule),
    canActivate: [AuthGuard2],
  },





];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
